export default "__VITE_ASSET__XrkM7Bj3__"